module.exports = __webpack_public_path__ + "./img/muratlamm_logo.9d6577f448c554c4156a448155ca1e94.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/muratlamm_logo.png
// module id = ./public/img/muratlamm_logo.png
// module chunks = 0